<template>
  <div>
    <div class="mb-2">
      <h4 class="mb-25">Detail Stok Kendaraan</h4>
      <p class="text-body mb-0">
        Kelola stok di mobil, lihat retur konsumen, dan pantau request
        pengembalian stok ke gudang.
      </p>
    </div>

    <b-tabs v-model="tabIndex" pills>
      <b-tab title="Stok Mobil">
        <stok-mobil ref="stokMobil" @submitRetur="afterSubmitRetur" />
      </b-tab>
      <b-tab title="Stok Retur">
        <retur-konsumen ref="returKonsumen" />
      </b-tab>
      <b-tab title="Data Pengembalian">
        <pengembalian ref="pengembalian" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import StokMobil from "./components/Stok.vue";
import Pengembalian from "./components/Pengembalian.vue";
import ReturKonsumen from "./components/ReturKonsumen.vue";
import { BTabs, BTab } from "bootstrap-vue";

const TAB_STOK = 0;
const TAB_RETUR = 1;
const TAB_PENGEMBALIAN = 2;

export default {
  components: {
    StokMobil,
    Pengembalian,
    BTabs,
    BTab,
    ReturKonsumen,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  watch: {
    tabIndex(idx) {
      this.refreshTab(idx);
    },
  },
  methods: {
    refreshTab(idx) {
      this.$nextTick(() => {
        if (idx === TAB_STOK && this.$refs.stokMobil && this.$refs.stokMobil.getData) {
          this.$refs.stokMobil.getData();
        }
        if (
          idx === TAB_RETUR &&
          this.$refs.returKonsumen &&
          this.$refs.returKonsumen.getReturData
        ) {
          this.$refs.returKonsumen.getReturData();
        }
        if (
          idx === TAB_PENGEMBALIAN &&
          this.$refs.pengembalian &&
          this.$refs.pengembalian.refresh
        ) {
          this.$refs.pengembalian.refresh();
        }
      });
    },
    afterSubmitRetur() {
      this.$bvModal.hide("retur-modal");
      this.tabIndex = TAB_PENGEMBALIAN;
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            pengembalian: "1",
          },
        })
        .catch(() => {});
      this.$nextTick(() => {
        if (this.$refs.pengembalian && this.$refs.pengembalian.refresh) {
          this.$refs.pengembalian.refresh();
        }
      });
    },
  },
  created() {
    if (this.$route.query.pengembalian) {
      this.tabIndex = TAB_PENGEMBALIAN;
    }
  },
  mounted() {
    // Initial load for active tab (created of child may have run already)
    this.refreshTab(this.tabIndex);
  },
};
</script>
